<template>
    <div id="katalog-tiket">
        <ol class="breadcrumb pull-right">
            <li><router-link :to="{ path: '/' }">Home</router-link></li>
            <li>Pembayaran</li>
            <li class="active">Katalog Tiket</li>
        </ol>

        <h1 class="page-header">Katalog Tiket</h1>

        <div class="row">
            <div class="col-md-12">
                <div class="panel panel-inverse">
                    <div class="panel-heading">
                        <div class="pull-right">
                            <button
                                type="button"
                                class="btn btn-success btn-xs m-r-5"
                                @click="createKatalogTiket()"
                            >
                                <span class="fa fa-plus"></span> Tambah Katalog
                                Tiket
                            </button>
                            <button
                                type="button"
                                class="btn btn-success btn-xs dropdown-toggle"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                Action <span class="caret"></span>
                            </button>
                            <ul class="dropdown-menu">
                                <li>
                                    <a
                                        @click="
                                            updateAllKatalogTiketStatus(
                                                status.PUBLISH,
                                            )
                                        "
                                        >Publish All</a
                                    >
                                </li>
                                <li>
                                    <a
                                        @click="
                                            updateAllKatalogTiketStatus(
                                                status.UNPUBLISH,
                                            )
                                        "
                                        >Unpublish All</a
                                    >
                                </li>
                            </ul>
                        </div>
                        <h4 class="panel-title">List Katalog Tiket</h4>
                    </div>

                    <div class="panel-body">
                        <app-datatable
                            :items="katalogTiketList"
                            :has-action="true"
                            :has-custom-pagination="true"
                            :has-custom-search="true"
                            :custom-pagination-current-page="
                                pagination.currentPage
                            "
                            :custom-pagination-per-page="pagination.perPage"
                            :custom-pagination-total-pages="
                                pagination.totalPages
                            "
                            :custom-pagination-sort-mode="pagination.sortMode"
                            :headers="headers"
                            v-on:selected="selectedRow = $event"
                            v-on:dblClicked="updateKatalogTiket()"
                            v-on:deleted="deleteKatalogTiket($event)"
                            v-on:changePage="
                                pagination = {
                                    ...pagination,
                                    currentPage: $event,
                                }
                            "
                            v-on:changeSortMode="
                                pagination = { ...pagination, sortMode: $event }
                            "
                            v-on:doSearch="
                                search = {
                                    query: $event.value,
                                    by: headersKey[$event.key],
                                }
                            "
                        />
                    </div>
                </div>
            </div>
        </div>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import DataTable from "@/modules/global/components/plugins/DataTable";
import Moment from "moment";
import SalesService from "@/modules/global/services/sales.js";
import Spinner from "@/modules/global/components/plugins/Spinner";

export default {
    name: "katalog-tiket",

    components: {
        "app-datatable": DataTable,
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            isLoading: false,
            katalogTiketList: [],
            status: {
                PUBLISH: "PUBLISHED",
                UNPUBLISH: "UNPUBLISHED",
            },
            selectedRow: null,
            search: null,
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            type: {
                SCHEDULED_TRYOUT: "SCHEDULED_TRYOUT",
                INSTANT_TRYOUT: "INSTANT_TRYOUT",
                CONSULTATION: "CONSULTATION",
                DUEL: "DUEL",
                ITEM_BANK: "ITEM_BANK",
                VIDEO: "VIDEO",
            },
            headers: [
                "Title",
                "Type",
                "Ticket",
                "Value",
                "Status",
                "Created At",
            ],
            headersKey: [
                "title",
                "type",
                "ticket",
                "value",
                "status",
                "createdAt",
            ],
        };
    },

    mounted: function () {
        this.fetchData();
    },

    watch: {
        pagination: function () {
            this.fetchData();
        },
    },

    methods: {
        fetchData: function () {
            var context = this;
            var search = this.search;
            var pagination = {
                perPage: this.pagination.perPage,
                currentPage: this.pagination.currentPage,
                sortMode: this.pagination.sortMode,
            };

            this.isLoading = true;

            SalesService.getKatalogTiketList(
                pagination,
                search,
                function (result) {
                    context.katalogTiketList = [];
                    context.isLoading = false;

                    if (result.success) {
                        result.data.forEach(function (content) {
                            var value = content.value;

                            if (content.type === context.type.SCHEDULED_TRYOUT)
                                value += " TO";
                            if (content.type === context.type.DUEL) value = "-";
                            if (
                                content.type === context.type.INSTANT_TRYOUT ||
                                content.type === context.type.ITEM_BANK ||
                                content.type === context.type.VIDEO
                            ) {
                                value += " bulan";
                            }

                            var row = {
                                id: content.id,
                                data: [
                                    content.title,
                                    content.type,
                                    content.ticket,
                                    value,
                                    content.status,
                                    Moment(content.created_at).format(
                                        "YYYY-MM-DD",
                                    ) || "-",
                                ],
                            };

                            context.pagination.totalPages = content.page;
                            context.katalogTiketList.push(row);
                        });
                    } else {
                        alert("Terjadi Kesalahan : " + result.data.message);
                    }
                },
            );
        },

        createKatalogTiket: function () {
            this.$router.push({ path: "/katalog-tiket/form" });
        },

        updateKatalogTiket: function () {
            var katalogId = this.selectedRow.id;
            this.$router.push({
                path: "/katalog-tiket/form",
                query: { id: katalogId },
            });
        },

        updateAllKatalogTiketStatus: function (status) {
            var context = this;
            var confirmed = window.confirm(
                "Apakah anda yakin akan mengupdate semua status katalog?",
            );

            if (confirmed) {
                this.isLoading = true;
                SalesService.updateAllKatalogTiketStatus(
                    status,
                    function (result) {
                        context.isLoading = false;
                        if (result.success) {
                            alert("Data Terupdate");
                            context.fetchData();
                        } else {
                            alert("Terjadi Kesalahan : " + result.message);
                        }
                    },
                );
            }
        },

        deleteKatalogTiket: function (katalog) {
            var context = this;
            var katalogId = katalog.id;
            var confirmed = window.confirm(
                "Apakah anda yakin akan menghapus katalog ini?",
            );

            if (confirmed) {
                this.isLoading = true;
                SalesService.deleteKatalogTiket(katalogId, function (result) {
                    context.isLoading = false;
                    if (result.success) {
                        alert("Data Terhapus");
                        context.fetchData();
                    } else {
                        alert("Terjadi Kesalahan : " + result.message);
                    }
                });
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// KatalogTiket.vue?b9f7d11c